import type { ExecEdBTFLink, ExecEdBTFSectionKey } from "./types";

export const execEdBTFSectionKeys: ExecEdBTFSectionKey[] = [
  "about",
  "curriculum",
  "certificate",
  "facts",
  "brochure",
  "whyGetSmarter",
  "promoBanner",
];

export const execEdBTFLinks: ExecEdBTFLink[] = [
  {
    key: "about",
    label: "About",
    path: "#about",
  },
  {
    key: "curriculum",
    label: "Curriculum",
    path: "#curriculum",
  },
  {
    key: "certificate",
    label: "Certificate",
    path: "#certificate",
  },
  {
    key: "facts",
    label: "Facts",
    path: "#facts",
  },
  {
    key: "brochure",
    label: "Brochure",
    path: "#brochure",
  },
  {
    key: "whyGetSmarter",
    label: "Why GetSmarter?",
    path: "#whygetsmarter",
  },
];
